import { GlAlert } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'DismissibleAlert',
    components: {
        GlAlert
    },
    directives: {
        SafeHtml
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        html: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            isDismissed: false
        };
    },
    methods: {
        dismiss () {
            this.isDismissed = true;
        }
    }
};
